import { render, staticRenderFns } from "./CountryRedirect.vue?vue&type=template&id=ae9625fa&"
import script from "./CountryRedirect.vue?vue&type=script&lang=js&"
export * from "./CountryRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9625fa')) {
      api.createRecord('ae9625fa', component.options)
    } else {
      api.reload('ae9625fa', component.options)
    }
    module.hot.accept("./CountryRedirect.vue?vue&type=template&id=ae9625fa&", function () {
      api.rerender('ae9625fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/CountryRedirect.vue"
export default component.exports